import { getTechnologyName } from '@kissui/helpers/src/catalog'

export const renderQuickView = ({
    sku,
    quick_view,
    tracking_list,
    tracking_position,
    campaign_creative,
    internationalId,
    internationalName,
    type,
    technologies,
    category,
    rawPrice,
    colors
}) => {
    if (!quick_view || !quick_view.label || !quick_view.popin_id) {
        return ''
    }

    const skuData = JSON.stringify({
        internationalId: internationalId,
        internationalName: internationalName,
        type: type,
        technology: getTechnologyName({ technologies }),
        category: category,
        rawPrice: rawPrice
    })
    let colorsSkusList = []
    if (typeof colors !== 'undefined') {
        colors.map(color => {
            colorsSkusList.push(color.sku)
        })
    }

    return `<nb-link
        color="gold"
        size="large"
        sku_colors="${colorsSkusList}"
        popin_id="${quick_view.popin_id}"
        sku='${sku}'
        sku_data='${skuData}'
        campaign_creative='${campaign_creative}'
        tracking_list='${tracking_list}'
        tracking_position='${tracking_position}'>${quick_view.label}</nb-link>`
}
